module.exports = __webpack_public_path__ + "static/media/money-bag.3dcae5a5.svg";